import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const LanguageContext = createContext({
  language: "es",
  setLanguage: () => {},
  isEn: false,
});

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    try {
      return localStorage.getItem("app_lang") === "en" ? "en" : "es";
    } catch {
      return "es";
    }
  });

  const setLanguage = useCallback((lang) => {
    const next = lang === "en" ? "en" : "es";
    setLanguageState(next);
    try {
      localStorage.setItem("app_lang", next);
    } catch {
      /* ignore */
    }
  }, []);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      isEn: language === "en",
    }),
    [language, setLanguage]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage debe usarse dentro de LanguageProvider");
  }
  return ctx;
}

export default LanguageContext;
